import { styled } from "@mui/styles";

const StyledOnboardingOverlay = styled('div')(() => ({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 11,
}));

const OnBoardingOverlay = ({ isOpen }) => {
    if (!isOpen) return null;
    return <StyledOnboardingOverlay />;
};

export default OnBoardingOverlay;
